<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'vch-pdp-text-image',
};
</script>
<style lang="scss" src="./pdp-text-image.scss"></style>
